import { Collapsible, Small } from "@fronterahealth/frontera-ui-components";

import { StickyNav } from "@pages/ClinicalReportDetails/Components/StickyNav/StickyNav";
import { useClinicalReportDetailsData } from "@providers/ClinicalReportDetailsProvider";

export const StickyNavCollapsible: React.FC = () => {
  const { reportSections } = useClinicalReportDetailsData();
  return (
    <div
      id="report-side-nav"
      className="bg-white rounded-3xl py-1 pl-4 pr-0 border-limestone-100 border w-full min-h-0 flex flex-col [&>div>button>svg]:hidden"
    >
      <Collapsible
        defaultOpenState={true}
        headerContent={
          <Small displayType="loud" colorType="primary" className="text-sm pb-2">
            On This Page
          </Small>
        }
        headerIsClickable={false}
        bodyContent={
          <div className="p-2 pr-4 overflow-y-auto max-h-[25vh]">
            <StickyNav sections={reportSections} />
          </div>
        }
      />
    </div>
  );
};
